import {
  Text,
  TextInput,
  Stack,
  SimpleGrid,
  Checkbox,
  Anchor,
} from '@mantine/core';

import CustomPasswordInput from '../../../CustomPasswordInput';

import { useSignUpFormContext } from '../../../../contexts/forms/SignUpFormContext';

import { PASSWORD_REQUIREMENTS } from '../../../../constants/signUpForm';

interface AdminDetailsProps {
  disableFields?: boolean;
}

export default function AdminDetails({
  disableFields = false,
}: AdminDetailsProps) {
  const { form } = useSignUpFormContext();

  return (
    <Stack>
      <TextInput
        label="Full Name"
        placeholder="John Doe"
        autoComplete="name"
        disabled={disableFields}
        {...form.getInputProps('full_name')}
      />
      <SimpleGrid cols={2}>
        <TextInput
          label="Phone Number"
          placeholder="+60 12 345 6789"
          autoComplete="tel"
          type="tel"
          disabled={disableFields}
          {...form.getInputProps('contact_number')}
        />
        <TextInput
          label="Email"
          placeholder="your-email@domain.com"
          type="email"
          autoComplete="email"
          disabled={disableFields}
          {...form.getInputProps('email')}
        />
      </SimpleGrid>
      <SimpleGrid cols={2}>
        <CustomPasswordInput
          enableStrengthMeter
          label="Password"
          autoComplete="new-password"
          popoverProps={{
            position: 'top-start',
          }}
          disabled={disableFields}
          {...PASSWORD_REQUIREMENTS}
          {...form.getInputProps('password')}
        />
        <CustomPasswordInput
          label="Confirm Password"
          autoComplete="new-password"
          disabled={disableFields}
          {...form.getInputProps('password_confirmation')}
        />
      </SimpleGrid>
      <Checkbox
        mt="md"
        label={
          <Text size="xs">
            I have read and agree on behalf of my company to adhere to
            Kakitangan.com&apos;s{' '}
            <Anchor
              inherit
              href="https://www.kakitangan.com/terms-and-conditions/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Use & Privacy Policy
            </Anchor>
          </Text>
        }
        disabled={disableFields}
        {...form.getInputProps('tncAgreed', { type: 'checkbox' })}
      />
    </Stack>
  );
}
